module.exports = __webpack_public_path__ + "img/jutai2.72fb7651.jpg";